import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const GoPage = lazyWithRetry(() => import("@/features/go/pages/GoPage").then((m) => ({ default: m.GoPage })));

export const GO_PATH = "/go";

const authRoutes: RouteConfig[] = [
  {
    path: GO_PATH,
    element: <GoPage />,
    isProtected: false,
    useMainLayout: false,
  },
];

export default authRoutes;
